import React from 'react';
import { Icon } from 'semantic-ui-react';
import { StepsWrapper } from 'react-lib/dist/components-es';

type Props = {
  currentStep: number;
  setCurrentStep: (arg: number) => void;
};

const InventoryDetailsCreateModeSteps = ({ currentStep, setCurrentStep }: Props) => {
  const steps = [
    {
      title: 'inventory.details.page.inventory.details.container.steps.1.title',
      iconComponent: <Icon className="icon-bond-plus" />,
      description: 'inventory.details.page.inventory.details.container.steps.1.description',
    },
    {
      title: 'inventory.details.page.inventory.details.container.steps.2.title',
      iconComponent: (
        <>
          <Icon className="icon-bond-list" />
          <Icon className="icon-tube-plus" />
        </>
      ),
      description: 'inventory.details.page.inventory.details.container.steps.2.description',
    },
  ];

  return <StepsWrapper steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} />;
};

export default React.memo(InventoryDetailsCreateModeSteps);
